import {HDate, Locale} from '@hebcal/hdate';
import {flags} from './event.js';
import {HolidayEvent} from './HolidayEvent.js';
import {smartApostrophe} from './string.js';
import './locale.js'; // Adds Hebrew and Ashkenazic translations

const ykk = 'Yom Kippur Katan';

/** YKK is minor day of atonement on the day preceeding each Rosh Chodesh */
export class YomKippurKatanEvent extends HolidayEvent {
  private readonly nextMonthName: string;
  /**
   * Normally created by {@link calendar} (via
   * `options.yomKippurKatan`) rather than directly.
   * @param date Hebrew date event occurs
   * @param nextMonthName name of the upcoming month
   */
  constructor(date: HDate, nextMonthName: string) {
    super(
      date,
      `${ykk} ${nextMonthName}`,
      flags.MINOR_FAST | flags.YOM_KIPPUR_KATAN
    );
    this.nextMonthName = nextMonthName;
    this.memo = `Minor Day of Atonement on the day preceeding Rosh Chodesh ${nextMonthName}`;
  }

  override basename(): string {
    return this.getDesc();
  }
  /**
   * @param [locale] Optional locale name (defaults to empty locale)
   */
  override render(locale?: string): string {
    const monthName0 = Locale.gettext(this.nextMonthName, locale);
    const monthName = smartApostrophe(monthName0);
    return `${Locale.gettext(ykk, locale)} ${monthName}`;
  }
  /**
   * @param [locale] Optional locale name (defaults to empty locale)
   */
  override renderBrief(locale?: string): string {
    return Locale.gettext(ykk, locale);
  }

  override url(): string | undefined {
    return undefined;
  }
}
